import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoratnagiritaxiservice() {



  const cardData = {
"keyword": "Pune to Ratnagiri Taxi Service",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Ratnagiri Taxi Service for travelers seeking safe, affordable, and convenient coastal transportation. Whether you are planning a family trip, beach vacation, temple visit, business travel, or weekend getaway, our taxi service ensures a smooth and stress-free journey. With experienced drivers, clean air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Ratnagiri. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible one-way and round-trip options, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable journey to one of Maharashtra’s most beautiful Konkan coastal destinations.",

"topPlaces": [
  {
    "title": "Ganpatipule Temple",
    "description":
      "Ganpatipule Temple is a famous Swayambhu Ganpati temple located on the Konkan coast near Ratnagiri, attracting devotees and tourists for darshan and scenic beauty."
  },
  {
    "title": "Ganpatipule Beach",
    "description":
      "Ganpatipule Beach is a clean and serene beach known for its white sand, calm waters, and peaceful atmosphere, perfect for relaxation and sunset views."
  },
  {
    "title": "Ratnadurga Fort",
    "description":
      "Ratnadurga Fort is a historic sea fort offering panoramic views of the Arabian Sea and surrounding coastline, making it a popular sightseeing spot in Ratnagiri."
  },
  {
    "title": "Thibaw Palace",
    "description":
      "Thibaw Palace is a heritage site in Ratnagiri that was once the residence of the exiled King of Burma, showcasing colonial-era architecture and history."
  },
  {
    "title": "Bhatye Beach",
    "description":
      "Bhatye Beach is a long and peaceful beach near Ratnagiri city known for its scenic beauty and calm environment, ideal for evening walks."
  },
  {
    "title": "Mandavi Beach",
    "description":
      "Mandavi Beach is located near Ratnadurga Fort and offers stunning views of the sea, fishing boats, and beautiful sunset scenes."
  },
  {
    "title": "Jaigad Fort & Lighthouse",
    "description":
      "Jaigad Fort and Lighthouse are major attractions near Ratnagiri offering breathtaking coastal views and historical significance."
  },
  {
    "title": "Prachin Konkan Museum",
    "description":
      "Prachin Konkan Museum showcases the traditional lifestyle, culture, and heritage of the Konkan region through life-size exhibits and models."
  },
  {
    "title": "Aare Ware Beach",
    "description":
      "Aare Ware Beach is a twin beach known for its untouched natural beauty, clean shoreline, and peaceful surroundings near Ratnagiri."
  },
  {
    "title": "Konkan Coastal Route",
    "description":
      "The Pune to Ratnagiri route passes through the Western Ghats, tunnels, valleys, and lush greenery, offering one of the most scenic road journeys in Maharashtra."
  }
],



services: [
  {
    name: "Pune to Ratnagiri Cab",
    description: "Pune to Ratnagiri cab service provides reliable transportation between Pune and Ratnagiri with comfortable vehicles and experienced drivers. Vehicles are suitable for highway and Konkan coastal travel ensuring smooth and safe journeys for families, tourists, and holiday travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ratnagiri. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Ratnagiri Taxi",
    description: "Pune to Ratnagiri taxi service offers dependable transportation for passengers traveling between Pune and Ratnagiri with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for beach holidays, Konkan tourism, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Ratnagiri. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab from Pune to Ratnagiri",
    description: "Cab from Pune to Ratnagiri service provides comfortable intercity transportation for passengers traveling for Konkan tourism, beach vacations, and family trips. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth journeys through scenic Konkan routes. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune and Ratnagiri. Ideal for one-way and round-trip travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Ratnagiri",
    description: "Taxi from Pune to Ratnagiri service offers reliable transportation with comfortable vehicles and professional drivers for travel between Pune and Ratnagiri. Vehicles provide smooth highway and coastal route travel suitable for tourism, sightseeing, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Ratnagiri. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Ratnagiri Cab Service",
    description: "Pune to Ratnagiri cab service provides dependable transportation solutions for passengers traveling between Pune and Ratnagiri with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for long-distance Konkan travel ensuring safe and smooth journeys for individuals, families, and group travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ratnagiri. Ideal for beach vacations, tourism, and holiday trips. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Ratnagiri Taxi Fare",
    description: "Pune to Ratnagiri taxi fare service provides transparent pricing information for passengers planning travel between Pune and Ratnagiri. Travelers can estimate transportation costs based on vehicle type, travel distance, and trip requirements. Comfortable vehicles ensure smooth highway travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ratnagiri. Flexible booking options allow convenient fare estimation and taxi reservations."
  },
  {
    name: "Pune to Ratnagiri One Way Cab",
    description: "Pune to Ratnagiri one way cab service provides economical transportation for passengers traveling from Pune to Ratnagiri without return travel requirements. Comfortable vehicles ensure smooth highway travel suitable for Konkan holidays, tourism, and family travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Ratnagiri including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Ratnagiri Round Trip Taxi",
    description: "Pune to Ratnagiri round trip taxi service offers convenient return transportation for passengers planning travel between Pune and Ratnagiri. Comfortable vehicles provide smooth highway journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ratnagiri. Ideal for tourism, sightseeing, and family vacations. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Pune to Ratnagiri Cab Booking",
    description: "Pune to Ratnagiri cab booking service allows passengers to reserve comfortable transportation between Pune and Ratnagiri. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ratnagiri. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Cheap Pune to Ratnagiri Cab",
    description: "Cheap Pune to Ratnagiri cab service provides affordable transportation between Pune and Ratnagiri with comfortable vehicles and economical pricing. Vehicles ensure reliable highway travel suitable for Konkan holidays, family journeys, and tourism. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Ratnagiri. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Ratnagiri Taxi",
    description: "Best Pune to Ratnagiri taxi service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth Konkan travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for coastal vacations, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ratnagiri. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Ratnagiri Cab",
    description: "Sedan Pune to Ratnagiri cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Ratnagiri. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for Konkan journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Ratnagiri. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Ratnagiri Taxi",
    description: "SUV Pune to Ratnagiri taxi service provides spacious transportation for families and groups traveling between Pune and Ratnagiri. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for coastal vacations and family journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Ratnagiri. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Ratnagiri Cab",
    description: "Innova Pune to Ratnagiri cab service provides premium SUV transportation for passengers seeking comfortable and reliable Konkan travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for coastal vacations, sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Ratnagiri. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Konkan Route Cab Pune Ratnagiri",
    description: "Konkan route cab Pune Ratnagiri service offers dependable transportation for passengers traveling through the scenic Konkan route from Pune to Ratnagiri. Comfortable vehicles ensure smooth highway and ghat travel suitable for beach holidays, sightseeing, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Ratnagiri. Flexible booking options allow convenient Konkan route cab reservations."
  }
],

tableData: [
  ["Pune to Ratnagiri Cab", "Pune to Ratnagiri Taxi"],
  ["Cab from Pune to Ratnagiri", "Taxi from Pune to Ratnagiri"],
  ["Pune to Ratnagiri Cab Service", "Pune to Ratnagiri Taxi Fare"],
  ["Pune to Ratnagiri One Way Cab", "Pune to Ratnagiri Round Trip Taxi"],
  ["Pune to Ratnagiri Cab Booking", "Cheap Pune to Ratnagiri Cab"],
  ["Best Pune to Ratnagiri Taxi", "Sedan Pune to Ratnagiri Cab"],
  ["SUV Pune to Ratnagiri Taxi", "Innova Pune to Ratnagiri Cab"],
  ["Konkan Route Cab Pune Ratnagiri", "Pune to Ratnagiri Cab Service"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Ratnagiri Taxi Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Ratnagiri taxi service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe Konkan travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Ratnagiri Cab Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Ratnagiri taxi pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Ratnagiri Taxi Availability",
        WhyChoosedescription: "Our Pune to Ratnagiri taxi service operates 24 hours a day for beach holidays, family tours, Konkan trips, business travel, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Taxis",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences for passengers visiting Ratnagiri."
      },
      {
        WhyChooseheading: "One Way & Round Trip Taxi Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Ratnagiri taxi service, round-trip bookings, Konkan sightseeing tours, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Taxi Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for families, tourists, business travelers, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Konkan Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Ratnagiri highway and ghat routes, ensuring safe driving, smooth travel, and timely arrival for every coastal journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Ratnagiri taxi service?", answer: "Pune to Ratnagiri taxi service provides comfortable taxi transportation between Pune and Ratnagiri for Konkan travel, beach holidays, and family tours." },
    { question: "Is Pune to Ratnagiri taxi service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Ratnagiri taxi service." },
    { question: "Which vehicles are available for Pune to Ratnagiri travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way taxi from Pune to Ratnagiri?", answer: "Yes, customers can book one-way as well as round-trip Pune to Ratnagiri taxi services." },
    { question: "Do you provide Ratnagiri sightseeing taxi packages?", answer: "Yes, Shivai Travels provides Ratnagiri sightseeing and customized Konkan travel packages." },
    { question: "Are all Pune to Ratnagiri taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book Pune to Ratnagiri taxi service online?", answer: "Yes, customers can easily book Pune to Ratnagiri taxi service online or through phone booking." },
    { question: "Do you provide taxis for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Pune to Ratnagiri taxi fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Ratnagiri taxi service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak tourist seasons." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kiran Jadhav",
    feedback:
      "Shivai Travels provided a very comfortable Pune to Ratnagiri taxi service with a smooth coastal drive, clean vehicle, and an experienced driver who ensured a safe journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Kulkarni",
    feedback:
      "The Pune to Ratnagiri cab service was highly reliable with timely pickup and a relaxed travel experience, making our Konkan trip enjoyable and stress-free.",
    rating: 5
  }
];

















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ratnagiri Taxi Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-ratnagiri-taxi.jpg",
  "description": "Book Pune to Ratnagiri taxi service for safe and comfortable Konkan coastal travel. Shivai Travels offers affordable one-way and round-trip cab booking with sedan, SUV, Innova, and luxury cab options available 24x7 for beach trips, family travel, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-ratnagiri-cab"
  }
};









  return (
    <div>

<Helmet>
  <title>Pune to Ratnagiri Taxi Service | Konkan Cab Booking | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Ratnagiri taxi service for one-way and round trip travel. Affordable cab options including sedan, SUV, Innova, and luxury cabs available 24x7 for Konkan route travel, beach visits, and family trips."
  />

  <meta
    name="keywords"
    content="pune to ratnagiri cab, pune to ratnagiri taxi, cab from pune to ratnagiri, taxi from pune to ratnagiri, pune to ratnagiri cab service, pune to ratnagiri taxi fare, pune to ratnagiri one way cab, pune to ratnagiri round trip taxi, pune to ratnagiri cab booking, cheap pune to ratnagiri cab, best pune to ratnagiri taxi, sedan pune to ratnagiri cab, suv pune to ratnagiri taxi, innova pune to ratnagiri cab, konkan route cab pune ratnagiri"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/91.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoratnagiritaxiservice;